import { useEffect, useContext, useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useForm } from 'utils/hooks'
import moment from 'moment'
import { A4 } from 'components/shared/print'
import { Button } from 'react-bootstrap'
import { Flex } from 'components/shared/flex'
import { selectYears, setPageSize, zeroPadding } from 'utils/util'
import { TransportationReport, TransportationReportSearchForm } from 'entities/transportation_report'
import { useFetchTransportationReportsApi } from 'api/transportation_report'
import { SelectField } from 'components/shared/input'
import { Institution } from 'entities/institution'
import { LedgerHeader } from 'components/ledger/ledger_componet'
import styled from 'styled-components'
import dayjs from 'dayjs'

type Props = {
    history: H.History
}
const Td = styled.td`
    border: solid 1px black;
    padding: 3px;
    text-align: center;
    font-size: 7px;
`

const ReceiveLedgerPage = (props: Props) => {
    const form = useForm<{ year: string; month: string }>({ year: moment().format('YYYY'), month: moment().format('MM') })
    const searchForm = useForm<TransportationReportSearchForm>({ ordering: 'transportation_report_pickup_date', perPage: 10000000 })
    const listApi = useFetchTransportationReportsApi(searchForm)
    const globalState = useContext(GlobalStateContext)

    useEffect(() => {
        setPageSize('landscape')
    }, [])

    useEffect(() => {
        globalState.setLoading(listApi.loading)
    }, [listApi.loading])

    useEffect(() => {
        searchForm.update((f) => {
            f.pickupDateAfter = `${form.object.year}-${form.object.month}-01`
            f.pickupDateBefore = `${form.object.year}-${form.object.month}-${new Date(Number(form.object.year), Number(form.object.month), 0).getDate()}`
        })
    }, [form.object])

    return (
        <>
            <ContentHeader
                className="no-print"
                headerTitle="検体受領・搬送作業日誌"
                right={
                    <Flex>
                        <SelectField form={form} attr="year" selectItems={selectYears()} style={{ width: 120 }} />
                        <SelectField
                            form={form}
                            attr="month"
                            selectItems={Array(12)
                                .fill(0)
                                .map((_, i) => ({ label: `${i + 1}月`, value: zeroPadding(i + 1, 2) }))}
                        />
                    </Flex>
                }
                left={
                    <>
                        <Button
                            onClick={() => {
                                window.print()
                            }}
                        >
                            印刷プレビュー
                        </Button>
                    </>
                }
            />
            {<ReceiveLedgerPaper transportationReports={listApi.response.results} />}
        </>
    )
}

export default withRouter(ReceiveLedgerPage)

type ReceiveLedgerPaperProps = {
    transportationReports: TransportationReport[]
}

const ReceiveLedgerPaper = (props: ReceiveLedgerPaperProps) => {
    const nRow = 15

    const data = useMemo(() => {
        const dataTmp: { transportationReport: TransportationReport; institution: Institution }[] = []
        props.transportationReports.forEach((tr) => {
            tr.institutions?.forEach((institution) => {
                dataTmp.push({ transportationReport: tr, institution: institution })
            })
        })
        return dataTmp
    }, [props.transportationReports])

    const page = Math.ceil(Math.max(data.length / nRow, 1))

    return (
        <>
            {Array(page)
                .fill(0)
                .map((_, i) => {
                    return (
                        <A4 key={'key'} padding={0} landscape={true} style={{ padding: 0 }}>
                            <div className={'preview-result'} style={{ width: '100%', padding: 20 }}>
                                <LedgerHeader
                                    headerTitle="検体受領・搬送作業日誌"
                                    recordTypeNum="RCL00001"
                                    originalDocument="LSOP-RCL002"
                                    versionNum="2"
                                    timestamp={dayjs().format('YYYYMMDDHHmm')}
                                ></LedgerHeader>
                                <div style={{ fontWeight: 'bold', fontSize: 10, margin: '20px 0', lineHeight: '11px' }}>
                                    <table style={{ width: '100%', border: 'solid 2px' }}>
                                        <thead>
                                            <tr>
                                                <Td style={{ fontSize: 9 }} colSpan={5} rowSpan={2}>
                                                    受領
                                                </Td>
                                                <Td style={{ fontSize: 9 }} colSpan={13}>
                                                    搬送
                                                </Td>
                                                <Td style={{ fontSize: 9 }} colSpan={2} rowSpan={2}>
                                                    申し送り事項
                                                </Td>
                                            </tr>
                                            <tr>
                                                <Td style={{ fontSize: 9 }} colSpan={6}>
                                                    → 搬送中継所
                                                </Td>
                                                <Td style={{ fontSize: 9 }} colSpan={7}>
                                                    → Craif中部検査センター
                                                </Td>
                                            </tr>
                                            <tr>
                                                <Td style={{ width: 50 }}>No.</Td>
                                                <Td style={{ width: 120 }}>
                                                    <div>委託元名称</div>（医療機関等名）
                                                </Td>
                                                <Td style={{ width: 75 }}>総受領検体数</Td>
                                                <Td style={{ width: 75 }}>
                                                    <div>依頼書枚数</div>
                                                    <div style={{ fontSize: 6 }}>（紙様式は「１」）</div>
                                                </Td>
                                                <Td style={{ width: 75 }}>
                                                    <div>受領年月日</div>・時刻
                                                </Td>
                                                <Td style={{ width: 70 }}>受領担当者</Td>
                                                <Td style={{ width: 75 }}>総搬送検体数</Td>
                                                <Td style={{ width: 75 }}>
                                                    <div>依頼書枚数</div> <div style={{ fontSize: 6 }}>（紙様式は「１」）</div>
                                                </Td>
                                                <Td style={{ width: 75 }}>
                                                    <div>冷蔵専用</div>搬送BOX数
                                                </Td>
                                                <Td style={{ width: 75 }}>搬送手段</Td>
                                                <Td style={{ width: 90 }}>
                                                    <div>搬入年月日</div>・時刻
                                                </Td>
                                                <Td style={{ width: 70 }}>搬入担当者</Td>
                                                <Td style={{ width: 75 }}>総搬送検体数*</Td>
                                                <Td style={{ width: 75 }}>冷蔵専用 搬送BOX数*</Td>
                                                <Td style={{ width: 75 }}>搬送手段*</Td>
                                                <Td style={{ width: 75 }}>
                                                    <div>搬出年月日</div>・時刻*
                                                </Td>
                                                <Td style={{ width: 70 }}>搬出担当者*</Td>
                                                <Td style={{ width: 75 }}>
                                                    <div>検査センター</div>確認者*
                                                </Td>
                                                <Td style={{ width: 45 }}>区分</Td>
                                                <Td style={{ width: 75 }}>詳細</Td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array(nRow)
                                                .fill(0)
                                                .map((_, index) => {
                                                    const t: TransportationReport = data[index + i * nRow]?.transportationReport
                                                    const it: Institution = data[index + i * nRow]?.institution
                                                    if (t && it) {
                                                        const sampleCount = t.sampleSet?.filter((s) => s.institutionId === it.id).length ?? 0
                                                        const hasChilledKit = t.sampleSet?.some((s) => s.isChilledTransport)
                                                        const chilledTransportBoxCount = hasChilledKit ? 1 : 0
                                                        const institutionInterviewCounts =
                                                            t.institutionsSheetCounts?.find((i) => i.institutionId === it.id)?.interviewSheetCount ?? 0
                                                        return (
                                                            <tr key={index}>
                                                                <Td>{index + 1}</Td>
                                                                <Td>{it.name}</Td>
                                                                <Td>{sampleCount}検体</Td>
                                                                <Td>{institutionInterviewCounts}枚</Td>
                                                                <Td>
                                                                    {t.pickupDate}
                                                                    <br />
                                                                    {dayjs(t.createdAt).format('HH:mm')}
                                                                </Td>
                                                                <Td>{t.pickupStaffName ?? '--'}</Td>
                                                                <Td>{sampleCount}検体</Td>
                                                                <Td>{institutionInterviewCounts}枚</Td>
                                                                <Td>{chilledTransportBoxCount}</Td>
                                                                <Td>自動車</Td>
                                                                <Td>
                                                                    {t.deliveryDate}
                                                                    <br />
                                                                    {dayjs(t.createdAt).format('HH:mm')}
                                                                </Td>
                                                                <Td>{t.pickupStaffName ?? '--'}</Td>
                                                                <Td>{sampleCount}検体</Td>
                                                                <Td>{chilledTransportBoxCount}</Td>
                                                                <Td>自動車</Td>
                                                                <Td>
                                                                    {t.deliveryDate}
                                                                    <br />
                                                                    {dayjs(t.createdAt).format('HH:mm')}
                                                                </Td>
                                                                <Td>{t.pickupStaffName ?? '--'}</Td>
                                                                <Td>{t.reportConfirmationUser?.fullName ?? '--'}</Td>
                                                                <Td></Td>
                                                                <Td>{t.note}</Td>
                                                            </tr>
                                                        )
                                                    }
                                                })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </A4>
                    )
                })}
        </>
    )
}
